export default "__VITE_ASSET__D2ZilWz3__"